<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h5>Depth of Burial (DoB) Survey Result</h5>
      <DoBSwitch @show-delta="(newValue) => updateShowDelta(newValue)"></DoBSwitch>
    </div>

    <DoBChartComponent
      :showDelta="showDelta"
      :data="chartData"
      :area-of-interest="areaOfInterest"
      :is-loading="isLoading"
      :show-legend="true"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, defineProps } from 'vue'
import { Alarm, AlarmClient, AreaOfInterest, DoBChart } from '@/server/MakeSenseApp-backend'
import DoBChartComponent from '../DoBChart.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'
import DoBSwitch from '@/components/charts/switches/DoBSwitch.vue'

const props = defineProps({
  alarm: Alarm
})

var showDelta = ref<boolean>(false)

function updateShowDelta(value: boolean) {
  showDelta.value = value
}

const chartData = ref<DoBChart | undefined>(undefined)
const isLoading = ref<boolean>(false)
const areaOfInterest = ref<AreaOfInterest | undefined>(undefined)
let store = useProjectStore()

onMounted(() => {
  const alarmClient = requiredInject<AlarmClient>('AlarmClient')

  if (props.alarm === undefined || props.alarm.id === undefined) {
    console.error('Alarm ID is undefined')
    return
  }

  isLoading.value = true

  alarmClient.doBForAlarm(store.projectId, props.alarm.id).then((data) => {
    areaOfInterest.value = data.areaOfInterest
    chartData.value = data as DoBChart
    isLoading.value = false
  })
})
</script>

<style scoped></style>
